import React from 'react'
import { FilterMenu } from './FilterMenu'
import { useContext } from './Context'

export const FilterButton = () => {
  const { onFilter, filterCategory, filterTemplate, commonFields } = useContext()
  return <FilterMenu {...{ onFilter, category: filterCategory, filterFields: commonFields.filterFields }} filterTemplate={filterTemplate} />
}
